import { APP_INITIALIZER, ApplicationConfig } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { Amplify } from "aws-amplify";

import { routes } from "./app.routes";
import { authInterceptor } from "./auth/auth.interceptor";
import { httpErrorInterceptor } from "./auth/http-error.interceptor";
import { environment } from "../environments/environment";
import { AuthService } from "./auth/auth.service";

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: environment.cognito.userPoolId,
            userPoolClientId: environment.cognito.userPoolClientId,
            loginWith: {
                oauth: {
                    domain: environment.cognito.oauthDomain,
                    scopes: ["openid", "email", "profile"],
                    redirectSignIn: [environment.cognito.redirectSignIn],
                    redirectSignOut: [environment.cognito.redirectSignOut],
                    responseType: "code"
                }
            }
        }
    }
});

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor])),
        provideNativeDateAdapter(),
        {
            // Collapse the subscript (hint/error) area of material inputs when empty instead of reserving fixed space
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: "dynamic" }
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (auth: AuthService) => () => auth.loadSession(),
            deps: [AuthService],
            multi: true
        }
    ]
};
